import script from "./appeal.vue?vue&type=script&setup=true&lang=js"
export * from "./appeal.vue?vue&type=script&setup=true&lang=js"

import "./appeal.vue?vue&type=style&index=0&id=7d4dca7c&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4dca7c"]])

export default __exports__